import {
    SerializedApp,
    AppAuthentication,
    AppFeatures,
    getGoogleSheetsSourceMetadata,
    AppDescription,
    getAppKindFromFeatures,
    AppKind,
} from "common/components/SerializedApp";
import { makeRandomAppSettings, ScreenDescriptionBuilder } from "common/generator/screens";
import { BuilderAppBuilder } from "common/generator/builder";
import { SourcePadState } from "../store/types";
import { EminenceFlags } from "common/Database/eminence";
import { makeSimpleAppDescriptionContext } from "common/generator/components";
import { assertNever } from "common/Support";
import { makePageFromSchema } from "common/generator/pages";

export function makeAppFromSource(
    appID: string,
    { schema, sourceMetadata }: SourcePadState,
    maybeAppTitle: string | undefined,
    authentication: AppAuthentication | undefined,
    appFeatures: AppFeatures,
    eminenceFlags: EminenceFlags
): SerializedApp | undefined {
    const appKind = getAppKindFromFeatures(appFeatures);
    const appTitle = maybeAppTitle ?? getGoogleSheetsSourceMetadata(sourceMetadata)?.title ?? "New app";
    const settings = makeRandomAppSettings(appTitle, authentication);

    let appDesc: AppDescription;
    if (appKind === AppKind.App) {
        const descBuilder = new ScreenDescriptionBuilder(appID, schema, appFeatures, eminenceFlags);
        appDesc = descBuilder.makeAppDescription(
            sourceMetadata,
            settings,
            // FIXME: Why aren't we passing `appFeatures` here?
            undefined
        );
    } else if (appKind === AppKind.Page) {
        appDesc = makePageFromSchema(schema, sourceMetadata, settings, appFeatures);
    } else {
        return assertNever(appKind);
    }

    const adc = makeSimpleAppDescriptionContext(appID, appDesc, undefined, schema);
    const appBuilder = new BuilderAppBuilder(adc, appFeatures, eminenceFlags);
    return appBuilder.buildApp();
}
